import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MxGraphChart = _resolveComponent("MxGraphChart")!
  const _component_ProgressIndicator = _resolveComponent("ProgressIndicator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MxGraphChart, {
      ref: "ganttChart",
      graphId: "ganttChart",
      initGraph: _ctx.initGraph
    }, null, 8, ["initGraph"]),
    _createVNode(_component_ProgressIndicator, {
      ref: "progress",
      id: "ganttchart-glasspane",
      type: "spinner"
    }, null, 512)
  ]))
}